import AdminPrintProductConfigurator from './AdminPurchasedCustomPrintConfigurator';

export default AdminPrintProductConfigurator;
